import axios from "axios";
import config from "./config";

const isSignedIn = (setSignedStatus) => {
  axios
    .get(`${config.LOGIN_SERVER_URL}/api/me`, {withCredentials: true})
    .then((response) => {
      setSignedStatus(!!response.data.user.email);
    })
    .catch(() => {
      setSignedStatus(false);
    });
};

export default isSignedIn;
